import { Table } from 'components/lib';
import React from 'react';
import styles from '../styles.module.scss';

export function EndorsementsTable({ changes, loading }) {
  return (
    <>
      <div className={styles.title}>
        Endorsements previously queued to be
        submitted along with this change
      </div>
      <div className={styles.line} />
      <div className={styles.tableWrapper}>
        <Table
          data={changes}
          loading={loading}
          badge={{
            col: 'status',
            color: 'gray',
          }}
        />
      </div>
    </>
  );
}
